var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 8 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: _vm.language["user.column.userName"] }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["user.column.userName"],
                              allowClear: ""
                            },
                            model: {
                              value: _vm.queryParam.username,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "username", $$v)
                              },
                              expression: "queryParam.username"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 8 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: { label: _vm.language["user.column.workNo"] }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["user.column.workNo"],
                              allowClear: ""
                            },
                            model: {
                              value: _vm.queryParam.workNo,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "workNo", $$v)
                              },
                              expression: "queryParam.workNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 8 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["column.realName"] } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["column.realName"],
                              allowClear: ""
                            },
                            model: {
                              value: _vm.queryParam.realname,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "realname", $$v)
                              },
                              expression: "queryParam.realname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 8 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["user.column.phone"] } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["user.column.phone"],
                              allowClear: ""
                            },
                            model: {
                              value: _vm.queryParam.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "phone", $$v)
                              },
                              expression: "queryParam.phone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.toggleSearchStatus
                    ? [
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label: _vm.language["user.column.userType"]
                                }
                              },
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder:
                                        _vm.language["common.pleaseChoose"] +
                                        _vm.language["user.column.userType"],
                                      allowClear: ""
                                    },
                                    model: {
                                      value: _vm.queryParam.userType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "userType",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.userType"
                                    }
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "employee" } },
                                      [_vm._v(_vm._s(_vm.language["employee"]))]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "nonemployee" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.language["nonemployee"])
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label: _vm.language["user.column.sex"]
                                }
                              },
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder:
                                        _vm.language["common.pleaseChoose"] +
                                        _vm.language["user.column.sex"],
                                      allowClear: ""
                                    },
                                    model: {
                                      value: _vm.queryParam.sex,
                                      callback: function($$v) {
                                        _vm.$set(_vm.queryParam, "sex", $$v)
                                      },
                                      expression: "queryParam.sex"
                                    }
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "1" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.language["common.sex.man"])
                                        )
                                      ]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "2" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.language["common.sex.woman"]
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.language["user"] +
                                    _vm.language["user.column.status"]
                                }
                              },
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder:
                                        _vm.language["common.pleaseChoose"],
                                      allowClear: ""
                                    },
                                    model: {
                                      value: _vm.queryParam.status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.queryParam, "status", $$v)
                                      },
                                      expression: "queryParam.status"
                                    }
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "1" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.language["downBoxValue.normal"]
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "2" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.language["downBoxValue.freeze"]
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.application.applicationType === "platform"
                          ? _c(
                              "a-col",
                              { attrs: { xl: 10, lg: 11, md: 12, sm: 24 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: _vm.language["application"]
                                    }
                                  },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        staticStyle: {
                                          width: "35%",
                                          "padding-right": "10px"
                                        },
                                        attrs: {
                                          allowClear: "",
                                          placeholder:
                                            _vm.language[
                                              "common.pleaseChoose"
                                            ] + _vm.language["application"]
                                        },
                                        model: {
                                          value:
                                            _vm.queryParam
                                              .selectedApplicationId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.queryParam,
                                              "selectedApplicationId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryParam.selectedApplicationId"
                                        }
                                      },
                                      _vm._l(_vm.applicationOptions, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: index,
                                            attrs: {
                                              value: item.id,
                                              allowClear: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  item.applicationNameLanguage ||
                                                    item.applicationName
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      }),
                                      1
                                    ),
                                    _c(
                                      "a-radio-group",
                                      {
                                        on: { change: _vm.change },
                                        model: {
                                          value: _vm.queryParam.applicationBy,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.queryParam,
                                              "applicationBy",
                                              $$v
                                            )
                                          },
                                          expression: "queryParam.applicationBy"
                                        }
                                      },
                                      [
                                        _c(
                                          "a-radio",
                                          { attrs: { value: "user" } },
                                          [_vm._v(_vm._s(_vm.language["user"]))]
                                        ),
                                        _c(
                                          "a-radio",
                                          { attrs: { value: "role" } },
                                          [_vm._v(_vm._s(_vm.language["role"]))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("a-col", { attrs: { md: 6, sm: 8 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        ),
                        _c(
                          "a",
                          {
                            staticStyle: { "margin-left": "8px" },
                            on: { click: _vm.handleToggleSearch }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.toggleSearchStatus
                                    ? _vm.language["common.foldButton"]
                                    : _vm.language["common.unfoldButton"]
                                ) +
                                "\n              "
                            ),
                            _c("a-icon", {
                              attrs: {
                                type: _vm.toggleSearchStatus ? "up" : "down"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _c("i", {
                staticClass: "anticon anticon-info-circle ant-alert-icon"
              }),
              _vm._v(_vm._s(_vm.language["common.choosed"]) + " "),
              _c("a", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.selectedRowKeys.length))
              ]),
              _vm._v(_vm._s(_vm.language["common.item"]) + "  \n      "),
              _c(
                "a",
                {
                  staticStyle: { "margin-left": "24px" },
                  on: { click: _vm.onClearSelected }
                },
                [_vm._v(_vm._s(_vm.language["common.clear"]))]
              )
            ]
          ),
          _c("a-table", {
            ref: "table",
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange
              },
              scroll: { x: true }
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "avatarslot",
                fn: function(text, record, index) {
                  return [
                    _c(
                      "div",
                      { staticClass: "anty-img-wrap" },
                      [
                        _c("a-avatar", {
                          attrs: {
                            shape: "square",
                            src: _vm.getAvatarView(record.avatar),
                            icon: "user"
                          }
                        })
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "email",
                fn: function(text, record, index) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title: record.email,
                          placement: "topLeft",
                          disabled: false
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(record.email))])]
                    )
                  ]
                }
              },
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a-dropdown",
                        [
                          _c(
                            "a",
                            { staticClass: "ant-dropdown-link" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.language["common.more"]) +
                                  " "
                              ),
                              _c("a-icon", { attrs: { type: "down" } })
                            ],
                            1
                          ),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDetail(record)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.language["common.detailsButton"]
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleAuthor(record)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s("授權"))]
                                )
                              ]),
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleAuthorAll(record)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s("一鍵授權"))]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("user-modal", { ref: "modalForm", on: { ok: _vm.modalFormOk } }),
      _c("GiftCompanyAuthListModal", {
        ref: "companyAuthListModal",
        on: { ok: _vm.modalFormOk }
      }),
      _c("password-modal", {
        ref: "passwordmodal",
        on: { ok: _vm.passwordModalOk }
      }),
      _c("password-batch-modal", { ref: "passwordbatchmodal" }),
      _c("sys-user-agent-modal", { ref: "sysUserAgentModal" }),
      _c("user-recycle-bin-modal", {
        attrs: { visible: _vm.recycleBinVisible },
        on: {
          "update:visible": function($event) {
            _vm.recycleBinVisible = $event
          },
          ok: _vm.modalFormOk
        }
      }),
      _c("user-application-model", {
        ref: "UserApplicationModel",
        on: { ok: _vm.modalFormOk }
      }),
      _c("user-upload-or-download-modal", {
        ref: "UserUploadOrDownloadModal",
        on: {
          ok: function($event) {
            return _vm.loadData(1)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }